import { format } from "date-fns";

export default function formatDate(date) {
    if (Array.isArray(date)) {
        return date.map((d) => format(new Date(d), "dd/MM/yy")).join(", ");
    }

    return date ? format(new Date(date), "dd/MM/yy") : "";
}
